(() => {
  const TARGET_SECTIONS = [
    "shopify-section-template--20612080992448__section_VNEbyF",
    "shopify-section-template--20612080992448__section_NtPwQT",
    "shopify-section-template--20612080992448__section_7etzNm",
    "shopify-section-template--20612080992448__section_WbdGyK"
  ];

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const isInsideUi = (el) =>
    el.closest("header, footer, nav, dialog, [role='dialog'], .drawer, .modal, .popup, .cart-drawer");

  const splitHeading = (el) => {
    if (!el || el.dataset.scrollSplit === "true") return;

    const text = el.textContent;
    if (!text || !text.trim()) return;

    el.dataset.originalText = text;
    el.dataset.scrollSplit = "true";

    const wrapper = document.createElement("span");
    wrapper.className = "sr-scroll-chars";

    const words = text.split(" ");

    words.forEach((word, wordIndex) => {
      const wordSpan = document.createElement("span");
      wordSpan.className = "sr-scroll-word";

      [...word].forEach((char) => {
        const span = document.createElement("span");
        span.className = "sr-scroll-char";
        span.textContent = char;
        wordSpan.appendChild(span);
      });

      wrapper.appendChild(wordSpan);

      if (wordIndex < words.length - 1) {
        const space = document.createElement("span");
        space.className = "sr-scroll-space";
        space.innerHTML = "&nbsp;";
        wrapper.appendChild(space);
      }
    });

    el.textContent = "";
    el.appendChild(wrapper);
  };

  const getTargets = () => {
    const sections = TARGET_SECTIONS
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    const targets = [];

    sections.forEach((section) => {
      if (isInsideUi(section)) return;

      section.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((heading) => {
        splitHeading(heading);
        targets.push(heading);
      });
    });

    return targets;
  };

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const updateHeading = (heading) => {
    const rect = heading.getBoundingClientRect();
    const vh = window.innerHeight;

    const start = vh * 0.88;
    const end = vh * 0.38;

    const progress = clamp((start - rect.top) / (start - end), 0, 1);

    const chars = heading.querySelectorAll(".sr-scroll-char");
    const visibleCount = Math.floor(progress * chars.length);

    chars.forEach((char, index) => {
      char.classList.toggle("is-visible", index < visibleCount);
    });
  };

  let ticking = false;
  let targets = [];

  const updateAll = () => {
    targets.forEach(updateHeading);
    ticking = false;
  };

  const requestTick = () => {
    if (!ticking) {
      requestAnimationFrame(updateAll);
      ticking = true;
    }
  };

  const init = () => {
    targets = getTargets();

    if (!targets.length) return;

    if (prefersReducedMotion) {
      targets.forEach((heading) => {
        heading.querySelectorAll(".sr-scroll-char").forEach((char) => {
          char.classList.add("is-visible");
        });
      });
      return;
    }

    updateAll();
    window.addEventListener("scroll", requestTick, { passive: true });
    window.addEventListener("resize", requestTick);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
  document.addEventListener("shopify:section:select", init);
})();